import appPages from "../../../../../appPages";
import AppConfig from '../../../../../config/AppConfig';

export default {
  introduction: {
    name: "introduction",
    index: 1,
    text: "Introduction to Mana",
    duration: 5,
    isComplete: true,
    page: appPages.onboardingPage,
  },
  account: {
    index: 2,
    name: "account",
    text: "Create an Account",
    duration: 2,
    isComplete: true,
  },
  profile: {
    name: "profile",
    index: 3,
    text: "Set up Profile",
    duration: 1,
    isComplete: false,
    page: appPages.onboardingInfoPage,
  },
  integrations: {
    index: 4,
    name: "integrations",
    text: "Set up Integrations",
    duration: 5,
    isComplete: false,
    page: appPages.integrationsOnboarding,
  },
  elements: {
    index: 5,
    name: "elements",
    text: "Customize Elements",
    duration: 5,
    isComplete: false,
    page: appPages.customizeElementsPage,
  },
  goals: {
    index: 6,
    name: "goals",
    text: "Set a Goal",
    duration: 2,
    isComplete: false,
    page: appPages.resolutionPage,
  },
  has_scheduled_call: {
    index: 7,
    name: "has_scheduled_call",
    text: "Schedule $10 Coaching Special",
    duration: 2,
    isComplete: false,
    page: AppConfig.STRIPE_URL,
  },
  autotrack: {
    index: 8,
    name: "track",
    text: "Track your time",
    duration: 5,
    isComplete: false,
    isLocked: false,
    page: appPages.trackHome,
    params: { showOverlay: true }, 
  },
  reflection: {
    index: 9,
    name: "reflection",
    text: "Reflect on your First Day",
    lockedText: "Available after you track time!",
    duration: 2,
    isComplete: false,
    isLocked: true,
    page: appPages.reflectionPage,
    params: { timeUnit: "day" },
  },
};
